export function reduceHooks(hooks: any[], initial: any, meta: any = {}) {
    return hooks.reduce((prev, next) => {
        const nextValue = next(prev, meta);
        return nextValue;
    }, initial);
}

export function makePropGetter(hooks: any[], meta: any = {}) {
    return (userProps: any = {}) => {
        return [...hooks, userProps].reduce(
            (prev, next) =>
                handlePropGetter(prev, next, {
                    ...meta,
                    userProps,
                }),
            {},
        );
    };
}
/**
 * Stolen from React Table
 *
 * @param prevProps
 * @param userProps
 * @param meta
 * @returns
 */
function handlePropGetter(prevProps: any, userProps: any, meta?: any): any {
    // Handle a lambda, pass it the previous props
    if (typeof userProps === 'function') {
        return handlePropGetter({}, userProps(prevProps, meta));
    }

    // Handle an array, merge each item as separate props
    if (Array.isArray(userProps)) {
        return mergeProps(prevProps, ...userProps);
    }

    // Handle an object by default, merge the two objects
    return mergeProps(prevProps, userProps);
}
/**
 * Stolen from React Table
 *
 * @param propList
 * @returns
 */
function mergeProps(...propList: any[]) {
    return propList.reduce((props, next) => {
        const { style, className, ...rest } = next;

        props = {
            ...props,
            ...rest,
        };

        if (style) {
            props.style = props.style ? { ...(props.style || {}), ...(style || {}) } : style;
        }

        if (className) {
            props.className = props.className ? props.className + ' ' + className : className;
        }

        if (props.className === '') {
            delete props.className;
        }

        return props;
    }, {});
}

export function makeRender(instance: any, Comp: any, props: any) {
    return function Inner({ ...extraProps }: any) {
        return mainRender(Comp, { ...instance, ...props, ...extraProps });
    };
}

makeRender.displayName = 'Make Renderer';

function mainRender(Comp: any, props: any) {
    return isReactComponent(Comp) ? <Comp {...props} /> : Comp;
}

function isReactComponent(component: any) {
    return (
        isClassComponent(component) ||
        typeof component === 'function' ||
        isExoticComponent(component)
    );
}

function isClassComponent(component: any) {
    return (
        typeof component === 'function' &&
        (() => {
            const proto = Object.getPrototypeOf(component);
            return proto.prototype && proto.prototype.isReactComponent;
        })()
    );
}

function isExoticComponent(component: any) {
    return (
        typeof component === 'object' &&
        typeof component.$$typeof === 'symbol' &&
        ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description)
    );
}

export const loopHooks = (hooks: any[], context: any, meta: any = {}) =>
    hooks.forEach((hook) => {
        const nextValue = hook(context, meta);
        if (process.env.NODE_ENV !== 'production') {
            if (typeof nextValue !== 'undefined') {
                console.info(hook, nextValue);
                throw new Error(
                    'React Table: A loop-type hook ☝️ just returned a value! This is not allowed.',
                );
            }
        }
    });
